export class Utils {
    static getRandomString(l = 16) {
        const c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLNMOPQRSTUVWXYZ0123456789';
        const cl = c.length;
        let r = '';
        for (let i = 0; i < l; i++) {
            r += c[Math.floor(Math.random() * cl)];
        }
        return r;
    }
}
Utils.isNotNull = (data) => (data !== undefined && data !== null ? true : false);
Utils.isNull = (data) => (data === undefined || data === null ? true : false);
Utils.abs = (val) => (val < 0 ? -val : val);
Utils.delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
